import {Provider} from '@angular/core';

import {ListProductUseCasePort} from '@features/product/application/use_cases/list-product/list-product.use-case.port';

import {ListProductUseCase} from '@features/product/application/use_cases/list-product/list-product.use-case';
import {ProductHttpAdapterProvider} from '@features/product/infrastructure/http/product.http.adapter.provider';

export const ListProductUseCaseProvider: Provider[] = [
  ...ProductHttpAdapterProvider,
  {
    provide: ListProductUseCasePort,
    useClass: ListProductUseCase
  }
];
